import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedOption,addResumenData, removeResumenData, setIdResumen, updateDominioPrincipal, updatePrice, updateResumenProperty, clearResumenData } from '../../globalslice';
import getDominioInfo from '../../services/DominioInfo';
import Transferencia from './Transferencia';
import DominioNo from './DominioNo';
import DominioAgregado from './DominioAgregado';
import '../../styles/Dominio.scss';
import bsqicon from '../../images/bsq-icon.svg';
import bsqicon2 from '../../images/bsq-icon-orange.svg';
import loadingIcon from '../../images/loading.png';
import { useTranslation } from 'react-i18next';
import getDomainPrices from '../../services/PriceDomain';
import calculatePriceDetails from '../../services/calculatePriceDetails';
import isProductWithHosting from '../../helpers/isProductWithHosting';
import validateAndCleanDomain from '../../helpers/validateAndCleanDomain';
import formatAmount from '../../helpers/formatAmount';

const Dominio = () => {

  const [dominio, setDominio] = useState('');
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSelectDomain, setLoadingSelectDomain] = useState(false);
  const [icon, setIcon] = useState(bsqicon);
  const [message, setMessage] = useState(null);
  const [inputError, setInputError] = useState(false);
  const [selectedDominios, setSelectedDominios] = useState([]);
  const [selectedPeriodos, setSelectedPeriodos] = useState({});
  const [productActual, setProductActual] = useState([]);
  const [msgresult, setMessageResult] = useState('green');
  const [visibleCount, setVisibleCount] = useState(4);
  const currency = useSelector((state) => state.global.currency);
  const selectedOption = useSelector((state) => state.global.selectedOption);
  const resumenData = useSelector(state => state.global.ResumenData);
  const idResumen = useSelector(state => state.global.idResumen);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  
  useEffect(() => {
    const productActual = resumenData.filter((item) => item.actual && item.product.id !== undefined);
    setProductActual(productActual.length > 0 ? productActual[0] : {});
  }, [resumenData]);

  useEffect(() => {
    const abortController = new AbortController();

    const updatePriceOnChange = async () => {
      // si tiene un dominio asignado
      if (productActual?.product?.domain_section[0]?.dominio_principal) {
        const domain = productActual.product.domain_section[0].dominio_principal;
        // obtenemos el item de resumenData que le corresponde al dominio
        const itemDomain = await resumenData.filter(
          (element) => element.actual && element.type === "domain" && element?.product?.domain_section[0]?.dominio_principal === domain
        );

        // si se encontró el dominio
        if (itemDomain.length > 0) {
          let domainPrice;
          const id = itemDomain[0]?.id ?? 0;
          const typeDomainRegister = itemDomain[0]?.product?.domain_section[0]?.domain_type ?? 'register';
          const dominioCambiarPeriod = parseInt(String(itemDomain[0]?.periodo).match(/\d+/)[0], 10);
          const domainPriceSin = await getDomainPrices({ domain, currency, type: "solo", typeDomainRegister }, abortController.signal);

          // si el dominio cuenta con hosting gratis, se obtienen los precios desde backend
          if (isProductWithHosting(productActual)) {
            const productId = productActual?.product?.id ?? 0;
            domainPrice = await getDomainPrices({ domain, currency, type: "con", typeDomainRegister, productId },abortController.signal);
          } else {
            // si el producto no cuenta con hosting gratis, se asigna el resultado de precio sin hosting
            domainPrice = domainPriceSin;
          }

          // verificamos que los precios sean correctos
          if (domainPrice && domainPriceSin) {
            const { newPrice, selectPeriods, selectPeriodsWithout } = calculatePriceDetails(domainPrice, domainPriceSin, dominioCambiarPeriod);
  
            dispatch(updatePrice({ id, newPrice }));

            // los dominios de transferencia se limitan a un año las periodicidades
            if (typeDomainRegister !== 'transfer') {
              dispatch(updateResumenProperty({ id, property: "selectPeriods", value: selectPeriods }));
              dispatch(updateResumenProperty({ id, property: "selectPeriodsWithout", value: selectPeriodsWithout }));
            }
          }
        }
      }
    };

    // si el producto actual es un OpenXchange, WordPress
    if (productActual?.isOX || productActual?.isWP) {
      updatePriceOnChange();
    }

    return () => {
      abortController.abort();
    };
  }, [productActual?.periodo]);
  
  const handleBuscar = async () => {
    
    if (dominio.trim() === '') {
      setInputError(true);
      return;
    }
    setSelectedDominios([]);
    setInputError(false);
    setLoading(true);

    try {
      setMessage(null);

      //validate the domain and set the state of dominio
      const domain_clean = await handleValidateDomain(dominio);

      // TLD not supported by neubox
      if (domain_clean && domain_clean === 'tld_register') {
        setMessage(t('cart.config.domain.not_valid_tld'));
        setMessageResult('red');
        setLoading(false);
        return;
      }
      //if the domain is not valid, show an error message and return
      else if (!domain_clean) {
        setMessage(t('cart.config.domain.not_valid'));
        setMessageResult('red');
        setLoading(false);
        return;
      }
      const dominiosYaAgregados = resumenData
      .filter((item) => item.product?.domain_section?.[0]?.dominio_principal)
      .map((item) => item.product.domain_section[0].dominio_principal);
      // Do the request with the cleaned domain
      const resultados = await getDominioInfo({
        dominio: domain_clean,
        currency,
        product_id: productActual?.product?.id ?? 0,
        domimniosAgregados: dominiosYaAgregados
      });
      
      if (resultados.success === 'success') {
        //validate if the domainss does not already exist in the cart
        let resultadoSuccess = resultados.resultados;
        resultadoSuccess = validateDomainsCart(resultadoSuccess);
        const existeDominio = resumenData.some(
          (item) =>
            item.type === "domain" &&
            item.product?.domain_section?.[0]?.dominio_principal === domain_clean
        );

        setResultados(resultadoSuccess);
        if(existeDominio){
          //existe ese dominio agregado asi que solo muestro el mensaje
          setMessage(t('cart.config.domain.ya_domain'));
          setMessageResult('red');
        } else {
          setMessage(resultados.message);
          setMessageResult(resultados.classerror);
        }
        setVisibleCount(4);
      } else {
        setMessage(resultados.message); 
        setMessageResult('red');
      }
    } catch (error) {
      setMessage('Error al buscar la información del dominio.');
      setMessageResult('red');
    } finally {
      setLoading(false);
    }
  };

  const handleOptionChange = (option) => {  
    dispatch(setSelectedOption(option));
    if(option === 'opc-bsq'){
      setResultados([]);
      setMessage(null);
      setDominio('');
      resumenData.forEach(element => {
          if(element.actual && element.type != 'domain'){
            dispatch(updateDominioPrincipal({ id: element.id, dominioPrincipal:null, domainType: null }));
          } else if(element.actual && element.type == 'domain'){
            dispatch(removeResumenData(element.id));
          }
      });
    }
  };

  const handleCheckboxChange = async (dominio, index, e) => {
    setLoadingSelectDomain(true);
    const abortController = new AbortController();
    const isChecked = e.target.checked; 
    let primero, cross, initprice = false;
    let dominioAgregar, costAgregar, periodoAgregar, secondPriceAgregar, 
      crossAgregar, nuevoDominio, idEliminar, privacyCost, privacy, encontrado = null;
    let selectPeriods, selectPeriodsWithout, dominioCambiar, dominioCambiarid, 
      dominioCambiarPeriod, dominioYaAgregado, dominioPrincipalActual, mismoDominio = null;

    if(isChecked){
      
      //valido si es el dominio principal
      dominioAgregar = dominio;
      if (selectedPeriodos[dominioAgregar]) {
        periodoAgregar = selectedPeriodos[dominioAgregar] === '1' ? 0 : selectedPeriodos[dominioAgregar] - 1;
      } else {
        periodoAgregar = 0;
      }

      primero = Array.isArray(selectedDominios) && selectedDominios.length === 0;
      
      //Validamos si ya existe un dominio principal
      resumenData.forEach(element => {
        //Si hay un dominio ya asignado al servicio actual hay que cambiarle el precio al dominio
        if(element.actual && element.type != 'domain' && element?.product?.domain_section[0]?.dominio_principal != null){
          dominioPrincipalActual = element?.product.domain_section[0].dominio_principal
        } 
        //validamos si el dominio que esta agregando es alguno que ya este en el carrito
        if(element?.product?.domain_section[0]?.dominio_principal == dominioAgregar){
          mismoDominio = true;
        }
      });
      //Si el dominioAgregar es igual a dominioPrincipal quiere decir que estoy intentado agregar el mismo dominio, asi que no hago nada
      if(dominioAgregar != dominioPrincipalActual && mismoDominio == null){
        // si no se ha agregado ningún dominio principal y aplica precio con dominio
        if (primero && isProductWithHosting(productActual)) {
          //se agrega el dominio como principal editar item de servicio + dominio
          if(resultados[index].precio[periodoAgregar].costo == 0 && resultados[index].precio[periodoAgregar].preciomostrado == 0){
            costAgregar = resultados[index].preciosin[periodoAgregar].preciomostrado ;
            secondPriceAgregar = resultados[index].precio[periodoAgregar].preciomostrado;
            crossAgregar = true;
          } else if (resultados[index].precio[periodoAgregar].tachado) {
            costAgregar = resultados[index].precio[periodoAgregar].preciomostrado ;
            secondPriceAgregar = resultados[index].precio[periodoAgregar].costo;
            crossAgregar = resultados[index].precio[periodoAgregar].tachado;
          } else if (resultados[index].precio[periodoAgregar].costo && resultados[index].precio[periodoAgregar].preciomostrado){
            costAgregar = resultados[index].precio[periodoAgregar].costo ;
            secondPriceAgregar = resultados[index].precio[periodoAgregar].preciomostrado;
            crossAgregar = false;
          } else {
            costAgregar = resultados[index].precio[periodoAgregar].costo ;
            secondPriceAgregar = resultados[index].precio[periodoAgregar].preciomostrado;
            crossAgregar = true;
          }

          selectPeriods = resultados[index].precio.reduce((acc, period, indexdeprecios) => {
            cross = period.costo == 0 ? true : false;
            initprice = period.costo == 0 ? resultados[index].preciosin[indexdeprecios].preciomostrado : period.preciomostrado;
            acc[period.periodo] = {
              cost: initprice,
              cross_price: cross,
              second_price: period.costo
            };
            return acc;
          }, {});

          selectPeriodsWithout = resultados[index].preciosin.reduce((acc, period, indexdeprecios) => {
            cross = period.costo == 0 ? true : false;
            initprice = period.costo == 0 ? resultados[index].preciosin[indexdeprecios].preciomostrado : period.preciomostrado;
            acc[period.periodo] = {
              cost: initprice,
              cross_price: cross,
              second_price: period.costo
            };
            return acc;
          }, {});

        } else {
          costAgregar = resultados[index].preciosin[periodoAgregar].costo;
          secondPriceAgregar = resultados[index].preciosin[periodoAgregar].preciomostrado;
          crossAgregar = resultados[index].preciosin[periodoAgregar].tachado !== undefined ? resultados[index].preciosin[periodoAgregar].tachado : false;

          selectPeriods = resultados[index].preciosin.reduce((acc, period) => {
            cross = period.costo != period.preciomostrado ? true : false;
            acc[period.periodo] = {
              cost: period.preciomostrado,
              cross_price: cross,
              second_price: period.costo
            };
            return acc;
          }, {});

          selectPeriodsWithout = resultados[index].precio.reduce((acc, period, indexdeprecios) => {
            cross = period.costo == 0 ? true : false;
            initprice = period.costo == 0 ? resultados[index].precio[indexdeprecios].preciomostrado : period.preciomostrado;
            acc[period.periodo] = {
              cost: initprice,
              cross_price: cross,
              second_price: period.costo
            };
            return acc;
          }, {});
        }

        if (resultados[index].protectionid !== undefined && resultados[index].protectionid === true) {
          privacyCost = resultados[index].protectionprice;
          privacy = resultados[index].protectionid;
        }
        
        //agregar item
        dispatch(addResumenData({
          product: {
            name: 'Registro de Dominio',
            smallname: 'Registro de Dominio',
            description: ``,
            domain_section: [
              {
                'dominio_principal': dominioAgregar,
                domain_type: 'register'
              }
            ],
            ...(privacy && { privacy_protection: false })
          },
          price:{
            cost: costAgregar,
            second_price: formatAmount(secondPriceAgregar),
            cross_price: crossAgregar,
            ...(privacyCost && { privacy_cost: privacyCost }),
            ...(privacyCost && { privacy_period: '1 año (s)' }),
            ...(privacyCost && { default_privacy_cost: privacyCost }),
          },
          periodo: periodoAgregar + 1 +  ' año (s)',
          id: idResumen,
          actual : true,
          type: 'domain',
          selectPeriods: selectPeriods,
          selectPeriodsWithout: selectPeriodsWithout,
        }));
        dispatch(setIdResumen());

        if(primero){
          //se tiene que cambiar el dominio principal del servicio
          resumenData.forEach(element => {
            if(element.actual && element.type != 'domain'){
              if(element.product.domain_section[0].dominio_principal){
                //si hay un dominio ya agregado, lo capturamos para poder modificar el precio
                dominioYaAgregado = element.product.domain_section[0].dominio_principal;
              }
              dispatch(updateDominioPrincipal({ id: element.id, dominioPrincipal:dominio, domainType: 'register' }));
            }
          });

          if(dominioYaAgregado){
            //ya habia un dominio asignado al servicio hay que cambiarle el precio porque ya no aplica
            //primero buscamos el dominio a cambiar
            resumenData.forEach(element => {
              if(element.actual && element.type == 'domain' && element.product.domain_section[0].dominio_principal == dominioYaAgregado){
                dominioCambiar = element.product.domain_section[0]?.dominio_principal;
                dominioCambiarid = element.id;
                dominioCambiarPeriod = parseInt(element.periodo.match(/\d+/)[0], 10);
              }
            });

            if(dominioCambiar != null){
              const domainPrice = await getDomainPrices({ domain: dominioCambiar, currency, type: 'con', typeDomainRegister: 'register', productId: productActual?.product?.id ?? 0 }, abortController.signal);
              const domainPriceSin = await getDomainPrices({ domain: dominioCambiar, currency, type: 'solo', typeDomainRegister: 'register' }, abortController.signal);
              const { newPrice, selectPeriods, selectPeriodsWithout } = calculatePriceDetails(domainPrice, domainPriceSin, dominioCambiarPeriod);

              dispatch(updatePrice({ id: dominioCambiarid, newPrice }));
              dispatch(updateResumenProperty({ id: dominioCambiarid, property:"selectPeriods", value: selectPeriods }));
              dispatch(updateResumenProperty({ id: dominioCambiarid, property:"selectPeriodsWithout", value: selectPeriodsWithout }));
            }
          }
        }

        //Si habia un dominio Principal, se remplazo asi que hay que cambiarle el precio
        if(dominioPrincipalActual != null){
          const domainPriceSin = await getDomainPrices({ domain: dominioPrincipalActual, currency, type: 'solo', typeDomainRegister: 'register' }, abortController.signal);
          const { newPrice, selectPeriods, selectPeriodsWithout } = calculatePriceDetails(domainPriceSin, domainPriceSin, 1);
          dispatch(updatePrice({ id: dominioCambiarid, newPrice }));
          dispatch(updateResumenProperty({ id: dominioCambiarid, property:"selectPeriods", value: selectPeriods }));
          dispatch(updateResumenProperty({ id: dominioCambiarid, property:"selectPeriodsWithout", value: selectPeriodsWithout }));
        }
      }
    } else {
      //se quito el dominio
      //valido si es el dominio principal
      if(dominio == selectedDominios[0]){
        //buscamos si hay otro dominio, para ponerlo ahora como principal
        resumenData.forEach(element => {
          if(element.type == "domain" && element.product.domain_section[0].dominio_principal != dominio && encontrado == null && element.actual && element.actual){
            //sera el nuevo dominio principal
            nuevoDominio = element.product.domain_section[0].dominio_principal;
            encontrado = true;
            dominioCambiar = element.product.domain_section[0]?.dominio_principal;
            dominioCambiarid = element.id;
            dominioCambiarPeriod = parseInt(element.periodo.match(/\d+/)[0], 10);
          }

          idEliminar = resumenData.findIndex(element => 
            element.product.domain_section[0].dominio_principal == dominio && element.type == "domain"
          );
        });

        resumenData.forEach(element => {
          if(element.actual && element.type != "domain" ){
            dispatch(updateDominioPrincipal({ id: element.id, dominioPrincipal:nuevoDominio, domainType: 'register' }));
          }
        });

        if(encontrado){
          //Cambiarle el precio ya que ahora es precio con hosting
          let domainPrice;
          const domainPriceSin = await getDomainPrices({ domain: nuevoDominio, currency, type: 'solo', typeDomainRegister: 'register' }, abortController.signal);
          // si el dominio cuenta con hosting gratis, se obtienen los precios desde backend
          if (isProductWithHosting(productActual)) {
            domainPrice = await getDomainPrices({ domain: nuevoDominio, currency, type: 'con', typeDomainRegister: 'register', productId: productActual?.product?.id ?? 0 }, abortController.signal);
          } else {
            // si el producto no cuenta con hosting gratis, se asigna el resultado de precio sin hosting
            domainPrice = domainPriceSin;
          }
          const { newPrice, selectPeriods, selectPeriodsWithout } = calculatePriceDetails(domainPrice, domainPriceSin, dominioCambiarPeriod);
         
          dispatch(updatePrice({ id: dominioCambiarid, newPrice }));
          dispatch(updateResumenProperty({ id: dominioCambiarid, property:"selectPeriods", value: selectPeriods }));
          dispatch(updateResumenProperty({ id: dominioCambiarid, property:"selectPeriodsWithout", value: selectPeriodsWithout }));
        }
      } else {
        //no es el dominio principal solo se tiene que eliminar
        idEliminar = resumenData.findIndex(element => 
          element.product.domain_section[0].dominio_principal == dominio
        );
      }

      dispatch(removeResumenData(resumenData[idEliminar].id));
    }
    if(mismoDominio == null){
      setSelectedDominios((prevSelected) => {
        if (prevSelected.includes(dominio)) {
          return prevSelected.filter((item) => item !== dominio);
        } else {
          return [...prevSelected, dominio];
        }
      });
  
    }
    setLoadingSelectDomain(false);
  };

  const handlePeriodoChange = (dominio, periodo) => {
    let nuevosPrecios = null;
    setSelectedPeriodos((prevPeriodos) => ({
      ...prevPeriodos,
      [dominio]: periodo,
    }));

    const index = resultados.findIndex(element => 
      element.dominio == dominio
    );

    if(selectedDominios.length > 0){
      //Ya hay algo seleccionado, podria ser al que le estoy cambiando la periodicidad
      if(dominio == selectedDominios[0] && isProductWithHosting(productActual)){
        //tomo precio resultados.precio
        nuevosPrecios = resultados[index].precio[periodo-1];
      }else {
        //tomo precio resultados.preciosin
        nuevosPrecios = resultados[index].preciosin[periodo-1];
      }
      
      resumenData.forEach(element => {
        if(element.type == 'domain'){
          if (element.product.domain_section && element.product.domain_section.length > 0) {
            if(element.product.domain_section[0].dominio_principal == dominio ){
              let cross = nuevosPrecios.tachado ? true : false;
              let  newPrice = {
                cost: nuevosPrecios.costo,
                cross_price: cross,
                second_price: nuevosPrecios.preciomostrado
              };
              dispatch(updatePrice({ id: element.id, newPrice }));
              dispatch(updateResumenProperty({ id: element.id, property:"periodo", value:periodo+" año (s)" }));
            }
          }
        }
      });
    }
  };

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 4);
  };

  /**
 * Delete domains that are already in the cart.
 *
 * This function compares the domains in `resultado` with the domains present in `resumenData`.
 * If a domain in `resultado` is already in the cart (determined by `resumenData`), it is removed from the result.
 */
  const validateDomainsCart = (resultado) => {
    let domainsToRemove = [];
    resumenData.forEach((product) => {
        domainsToRemove.push(product.product.domain_section[0].dominio_principal);
    });
    let response = resultado.filter(item => !domainsToRemove.includes(item.dominio));

    return response;
  };

  /**
   * This function validates the domain and returns the cleaned domain or null if it is not valid furhermore sets the state of domain
   * @param {*} domain 
   * @returns result or null
   */
  const handleValidateDomain = async (domain) => {
    const result = validateAndCleanDomain(domain, false, true, "register");
    if (!result.isValid) {
      return result.error; // Return null if not valid
    }
    setDominio(result.cleanDomain); // Set the state of domain

    return result.cleanDomain; // Return the cleaned domain
  };

  return (
    <div className="cf-period cf-domain">
      <h1>{t('cart.config.domain.title')}</h1>
      <p>{t('cart.config.domain.text')}</p>
      <DominioAgregado/>
      <div className={`bsq-dominio ${selectedOption === 'opc-bsq' ? 'active' : ''}`}>
        <div className='bsq-radio'>
          <input
            type="radio"
            name="sel-type"
            id="opc-bsq"
            checked={selectedOption === 'opc-bsq'}
            onChange={() => handleOptionChange('opc-bsq')}
          />
          <label className="opc-busqueda" htmlFor="opc-bsq">{t('cart.config.domain.register.label')}</label>
        </div>
        <div className={`contenido-busqueda ${selectedOption !== 'opc-bsq' ? 'bsq-hidden' : ''}`}>
          <div className='bsq-buscador'>
            <div className="input-container">
              <img src={icon} alt="Icon Busqueda" className="bsq-search-icon" />
              <input
                type="text"
                id="bsq-input-dominio"
                className={`form-control bsq-dominio-input ${inputError ? 'input-error' : ''}`}
                value={dominio}
                placeholder={t('cart.config.domain.register.placeholder')}
                onChange={(e) => {
                  setDominio(e.target.value);
                  setInputError(false);
                }}
                onFocus={() => setIcon(bsqicon2)} 
                onBlur={() => setIcon(bsqicon)} 
                onKeyDown={(e) => (e.key == 'Enter' && !loading) && handleBuscar()}
              />
            </div>
            <button className="bsq-btn-buscar" onClick={handleBuscar} disabled={loading}>{t('cart.config.domain.register.btn')}</button>
          </div>
          <div>
            {loading &&
              <div className='bsq-load'>
                <img src={loadingIcon} alt="Cargando..." className="bsq-load-icon" />
              </div>
            }
            {message && <p className={`bsq-res-error ${msgresult}`}>{message}</p>}
            {resultados.length > 0 && (
              <div className="resultados">
                {resultados.slice(0, visibleCount).map((resultado, index) => {
                  const selectedPeriodo = selectedPeriodos[resultado.dominio] || (resultado.precio[0] && resultado.precio[0].periodo);
                  const isFirstSelected = selectedDominios[0] === resultado.dominio;
                  let selectedPrecio;
                  if (selectedDominios.length === 0 || (selectedDominios.length > 0 && selectedDominios[0] === resultado.dominio)) {
                    // precio default
                    selectedPrecio = resultado.precio[selectedPeriodo - 1];

                    // si el producto no tiene hosting gratis
                    if (!isProductWithHosting(productActual)) {
                      selectedPrecio = resultado.preciosin[selectedPeriodo - 1];
                    }
                  } else {
                    selectedPrecio = resultado.preciosin[selectedPeriodo - 1];
                  }
                  const selectedPrecioSin = resultado.preciosin[selectedPeriodo - 1] || {};
                  
                  return (
                    <div key={index} className={`resultado-dominios ${selectedDominios.includes(resultado.dominio) ? 'selected' : ''}`}>
               
                        <div className='bsq-res-todos'>
                          <div className="bsq-res-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={index}
                              id={index}
                              checked={selectedDominios.includes(resultado.dominio)}
                              onChange={(e) => handleCheckboxChange(resultado.dominio, index, e)}
                              disabled={loadingSelectDomain}
                            />
                          </div>
                          <div className="bsq-res-dominio">
                            <label className="form-check-label bsq-dominio-resultado" htmlFor={resultado.dominio}>
                              {resultado.dominio}
                              {isFirstSelected && (
                                <span className={`${isFirstSelected ? 'first-selected' : 'bsq-first-def'}`}>{t('cart.config.domain.principal')}</span>
                              )}
                            </label>
                          </div>
                          <div className="bsq-res-select">
                            <select
                              className="bsq-res-select-opt"
                              value={selectedPeriodo}
                              onChange={(e) => handlePeriodoChange(resultado.dominio, e.target.value)} 
                              disabled={`${resultado.precio.length == 1 ? 'disabled' : ''}`}>
                              {resultado.precio.map((precio, idx) => (
                                <option value={precio.periodo} key={idx}>
                                  {precio.periodo === 1 ? '1 Año' : `${precio.periodo} Años`}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className='bsq-res-todos2'>
                          <div className="bsq-res-precios">
                            {(selectedPrecio.clausula == 'GRATIS con Hosting' && selectedPrecio.costo == 0)?
                              <span className="bsq-tachado">${selectedPrecioSin.costo} {currency}</span> 
                            : selectedPrecio.tachado && selectedPrecio.costo != 0 && (
                              <span className="bsq-tachado">${selectedPrecio.preciomostrado} {currency}</span>
                            )}
                            {selectedPrecio.tachado && selectedPrecio.costo == 0 && selectedPrecio.preciomostrado != 0 && selectedPrecio.clausula != 'GRATIS con Hosting'? (
                              <span className="bsq-tachado">${selectedPrecio.preciomostrado} {currency}</span>
                            ) : selectedPrecio.tachado && selectedPrecio.costo != 0 && selectedPrecio.preciomostrado != 0 && selectedPrecio.clausula != 'GRATIS con Hosting' ? (
                              <span className="bsq-costo">${formatAmount(selectedPrecio.costo)} {currency}</span>
                            ) : selectedPrecio.preciomostrado != 0 && selectedPrecio.clausula != 'GRATIS con Hosting' ? (
                              <span className="bsq-costo">${formatAmount(selectedPrecio.preciomostrado)} {currency}</span>
                            ) : null }
                            {selectedPrecio.clausula && (
                              <span className="bsq-clausula"> {selectedPrecio.clausula}</span>
                            )}
                          </div>
                        </div>
                      
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <div className='bsq-res-vermas'>
            {resultados.length > visibleCount && (
              <button onClick={handleShowMore} className="btn bsq-show-more">{t('cart.config.domain.mas_opciones')}</button>
            )}
          </div>
        </div>
      </div>
      <Transferencia productActual={productActual} />
      <DominioNo />      
    </div>
  );
}

export default Dominio;
